const React = require('react');
const { RadioButtonGroup, RadioButton, Link, Text, Card, IconButton } = require('@metro-ui/core');
const { Edit } = require('@metro-ui/icons');
const ReactIntl = require('react-intl');
const { includes } = require('lodash');
const injectIntl = ReactIntl.injectIntl;
const LoginActions = require('../../actions/LoginActions');
const LoginStore = require('../../stores/LoginStore');
const AppConstants = require('../../constants/AppConstants');
const defaultMessages = require('../../i18n/messages/default');
const LoginPreferencesCardWrapper = require('./LoginPreferencesCardWrapper');
const  LoginPreferencesV2 = require('./LoginPreferencesV2');

class AuthenticationContainer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            mfaOptions: '',
            maxMFAOptions: ''
        };

        this._onGetMFAOptions = this.onGetMFAOptions.bind(this);
    }

    componentDidMount() {
        LoginActions.getMFAOptions(this.props.userType, this.props.countryCode);
        LoginStore.addGetMFAOptionsListner(this._onGetMFAOptions);
    }

    componentWillUnmount() {
        LoginStore.removeGetMFAOptionsListner(this._onGetMFAOptions);
    }

    onGetMFAOptions() {
        let appState = LoginStore.getState();
        if (appState.mfaOptions) {
            this.setState({ mfaOptions: appState.mfaOptions.mfaOptions || [], maxMFAOptions: appState.mfaOptions.maxMFAOptions });
        }
    }

    render() {
        return (
          <React.Fragment>
            {this.state.maxMFAOptions > 2 ? (
              <LoginPreferencesV2 {...this.props} mfaOptions={this.state.mfaOptions}/>
            ) : (
              <AuthenticationFactors {...this.props} mfaOptions={this.state.mfaOptions}/>
            )}
          </React.Fragment>
        );
    }
}

class AuthenticationFactors extends React.Component {
    constructor(prop) {
        super(prop);
        this.state = {
            selectedValue: '',
            toastrMessage: '',
            toastrType: 'success',
            uAuthenticationMethod: this.props.userAuthenticationMethod
        };
        this.onRadioSelectionChange = this.onRadioSelectionChange.bind(this);
    }

    componentDidMount() {
        const userState = this.getUserCurrentState(this.props.userAuthenticationMethod);
        if(userState){
            LoginActions.triggerToast(userState.toastrMessage, userState.toastrType);
        }
    }
 
    getUserCurrentState(authenticationMethod) {
        var userType = this.props.userType;
        if (authenticationMethod === AppConstants.TWO_FA_TOTP_APP) {
            return {
                toastrMessage: this.props.intl.formatMessage(defaultMessages['loginpreferences.2fa.status_ok']),
                toastrType: 'success',
                selectedValue: 'otpGeneratorApp'
            };
        } else if (authenticationMethod === AppConstants.TWO_FA_TOTP) {
            return {
                toastrMessage: this.props.intl.formatMessage(defaultMessages['loginpreferences.2fa.status_ok']),
                toastrType: 'success',
                selectedValue: 'otpViaSms'
            };
        } else if (authenticationMethod === AppConstants.TWO_FA_WEB_AUTHN) {
            return {
                toastrMessage: this.props.intl.formatMessage(defaultMessages['loginpreferences.2fa.status_ok']),
                toastrType: 'success',
                selectedValue: 'optViaFingerprint'
            };
        } else if (authenticationMethod === AppConstants.LoginPreferences.AUTH_METHOD_USER_CREDENTIAL
            && userType === 'SUPP') {
            return {
                toastrMessage: this.props.intl.formatMessage(defaultMessages['loginpreferences.2fa.status_error']),
                toastrType: 'error',
                selectedValue: ''
            };
        } else if (authenticationMethod === AppConstants.LoginPreferences.AUTH_METHOD_USER_CREDENTIAL
            && userType !== 'SUPP') {
            return {
                toastrMessage: this.props.intl.formatMessage(defaultMessages['loginpreferences.2fa.status_warning']),
                toastrType: 'warning',
                selectedValue: ''
            };
        } else {
            return {
                toastrMessage: this.props.intl.formatMessage(defaultMessages['loginpreferences.2fa.status_error']),
                toastrType: 'error',
                selectedValue: ''
            };
        }
    }

    onRadioSelectionChange(event, value) {
        this.goToSelectedAuthMethod(value);
    }

    onAuthMethodEdit(value) {
        this.goToSelectedAuthMethod(value);
    }

    goToSelectedAuthMethod(value) {
        switch (value) {
            case 'otpGeneratorApp':
                this.setState({ selectedValue: value });
                LoginActions.getTwoFATempSecret(this.props.idToken, this.props.userType, this.props.traceId);
                this.props.onNavItemClick(3);
                break;
            case 'otpViaSms':
                LoginActions.getTwoFATempSecret(this.props.idToken, this.props.userType, this.props.traceId);
                this.setState({ selectedValue: value });
                this.props.onNavItemClick(4);
                break;
            case 'optViaFingerprint':
                // LoginActions.getTwoFATempSecret(this.props.idToken, this.props.userType, this.props.traceId);
                this.setState({ selectedValue: value });
                this.props.onNavItemClick(5);
                break;
            default:
                this.setState({ selectedValue: '' });
                break;
        }
    }

    render() {
        var userAuthenticationMethod = this.props.userAuthenticationMethod;
        var userState = this.getUserCurrentState(userAuthenticationMethod);
        var link_via_sms = this.props.intl.formatMessage(defaultMessages['loginpreferences.2famethods.codes_via_sms.how_it_works_url']);
        var link_via_app = this.props.intl.formatMessage(defaultMessages['loginpreferences.2famethods.codes_via_app.how_it_works_url']);
        var link_via_webauthn = this.props.intl.formatMessage(defaultMessages['loginpreferences.2famethods.webauthn.how_it_works_url']);
        return (
            <LoginPreferencesCardWrapper headingText={this.props.intl.formatMessage(defaultMessages['loginpreferences.2fa'])}>
                <RadioButtonGroup
                    onChange={this.onRadioSelectionChange}
                    className="authentication-radio-group"
                    value={userState.selectedValue}>
                    <div onClick={this.onRadioSelectionChange.bind(this)}>
                        {
                            (includes(this.props.mfaOptions, AppConstants.LoginPreferences.TWO_FA_TOTP_APP_OPTION_MAP)
                                || userAuthenticationMethod == AppConstants.TWO_FA_TOTP_APP) &&
                            <Card padding="small">
                                <RadioButton value="otpGeneratorApp">
                                    <Text size={{ l: "medium", xl: "medium", s: "small", xs: "medium" }} hasNoNativeMargin>
                                        <div>{this.props.intl.formatMessage(defaultMessages['loginpreferences.2famethods.codes_via_app'])}
                                            {userState.selectedValue == 'otpGeneratorApp' &&
                                                <IconButton
                                                    Icon={Edit}
                                                    hasNoInteractionEffect
                                                    label= {this.props.intl.formatMessage(defaultMessages['loginpreferences.2famethods.edit'])}
                                                    style={{ float: 'right' }}
                                                    color="blue"
                                                    onClick={this.onAuthMethodEdit.bind(this, 'otpGeneratorApp')}
                                                    size='small'
                                                />}
                                        </div>
                                    </Text>
                                    <Text size="small" hasNoNativeMargin>
                                        {this.props.intl.formatMessage(defaultMessages['loginpreferences.2famethods.codes_via_app.description'])}
                                    </Text>
                                    <Text size="small" hasNoNativeMargin>
                                        <Link href={link_via_app} target="_blank">
                                            {this.props.intl.formatMessage(defaultMessages['loginpreferences.2famethods.how_it_works'])}
                                        </Link>
                                    </Text>
                                </RadioButton>
                            </Card>
                        }
                        {
                            (includes(this.props.mfaOptions, AppConstants.LoginPreferences.TWO_FA_TOTP_SMS_OPTION_MAP)
                                || userAuthenticationMethod == AppConstants.TWO_FA_TOTP) &&
                            <Card padding="small">
                                <RadioButton
                                    id="otpViaSms"
                                    value="otpViaSms">
                                    <Text size={{ l: "medium", xl: "medium", s: "small", xs: "medium" }} hasNoNativeMargin>
                                        <div>{this.props.intl.formatMessage(defaultMessages['loginpreferences.2famethods.codes_via_sms'])}
                                            {userState.selectedValue == 'otpViaSms' &&
                                                <IconButton
                                                Icon={Edit}
                                                hasNoInteractionEffect
                                                label= {this.props.intl.formatMessage(defaultMessages['loginpreferences.2famethods.edit'])}
                                                style={{ float: 'right' }}
                                                color="blue"
                                                onClick={this.onAuthMethodEdit.bind(this, 'otpViaSms')}
                                                size='small'
                                            />}
                                        </div>
                                    </Text>
                                    <Text size="small" hasNoNativeMargin>
                                        {this.props.intl.formatMessage(defaultMessages['loginpreferences.2famethods.codes_via_sms.description'])}
                                    </Text>
                                    <Text size="small" hasNoNativeMargin>
                                        <Link href={link_via_sms} target="_blank" >
                                            {this.props.intl.formatMessage(defaultMessages['loginpreferences.2famethods.how_it_works'])}
                                        </Link>
                                    </Text>
                                </RadioButton>
                            </Card>
                        }
                        {
                            (includes(this.props.mfaOptions, AppConstants.LoginPreferences.TWO_FA_WEB_AUTHN_OPTION_MAP)
                                || userAuthenticationMethod == AppConstants.TWO_FA_WEB_AUTHN) &&

                            <Card padding="small">
                                <RadioButton
                                    id="optViaFingerprint"
                                    value="optViaFingerprint">
                                    <Text size={{ l: "medium", xl: "medium", s: "small", xs: "medium" }} hasNoNativeMargin>
                                        <div>{this.props.intl.formatMessage(defaultMessages['loginpreferences.2famethods.webauthn'])}
                                            {userState.selectedValue == 'optViaFingerprint' &&
                                                <IconButton
                                                Icon={Edit}
                                                hasNoInteractionEffect
                                                label= {this.props.intl.formatMessage(defaultMessages['loginpreferences.2famethods.edit'])}
                                                style={{ float: 'right' }}
                                                color="blue"
                                                onClick={this.onAuthMethodEdit.bind(this, 'optViaFingerprint')}
                                                size='small'
                                            />}
                                        </div>
                                    </Text>
                                    <Text size="small" hasNoNativeMargin>
                                        {this.props.intl.formatMessage(defaultMessages['loginpreferences.2famethods.webauthn.description'])}
                                    </Text>
                                    <Text size="small" hasNoNativeMargin>
                                        <Link href={link_via_webauthn} target="_blank" >
                                            {this.props.intl.formatMessage(defaultMessages['loginpreferences.2famethods.how_it_works'])}
                                        </Link>
                                    </Text>
                                </RadioButton>
                            </Card>
                        }
                    </div>
                </RadioButtonGroup>
            </LoginPreferencesCardWrapper>
        );
    }
}

module.exports = injectIntl(AuthenticationContainer);